import type { QuotationInvoicePaymentKind } from "@/modules/quotation-invoice/domain/types";

export function computeNetReceived(
  rows: { kind: QuotationInvoicePaymentKind; amount: number }[],
): number {
  let n = 0;
  for (const r of rows) {
    if (r.kind === "refund") n -= r.amount;
    else n += r.amount;
  }
  return Math.round(n * 100) / 100;
}
